
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 485 485"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M303.352 288.552c12.284 7.049 26.497 11.104 41.648 11.104 46.299 0 83.966-37.667 83.966-83.966S391.299 131.724 345 131.724c-1.026 0-2.042.041-3.059.078-8.594-34.742-27.889-66.241-55.295-89.835C255.212 14.904 215.03 0 173.5 0 77.832 0 0 77.832 0 173.5S77.832 347 173.5 347c27.81 0 54.381-6.386 78.977-18.979 19.167-9.815 36.531-23.318 50.875-39.469zm95.614-72.863c0 29.757-24.209 53.966-53.966 53.966s-53.965-24.209-53.965-53.966 24.208-53.965 53.965-53.965 53.966 24.209 53.966 53.965zM30 173.5C30 94.374 94.374 30 173.5 30c66.658 0 123.283 44.801 139.146 108.215-30.283 12.694-51.612 42.637-51.612 77.474 0 20.347 7.279 39.023 19.364 53.571C253.188 299.751 214.889 317 173.5 317 94.374 317 30 252.626 30 173.5z"}}),_c('path',{attrs:{"d":"M158.5 158.346l-93.525.154.05 30 123.475-.204V65h-30zM345 330c-77.196 0-140 62.804-140 140v15h280v-15c0-77.196-62.804-140-140-140zM236.019 455c6.666-48.679 45.302-87.311 93.981-93.978V430h30v-68.978c48.678 6.666 87.315 45.298 93.981 93.978H236.019z"}})])
          )
        }
      }
    